import { Fragment } from 'react';
import clsx from 'clsx';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import Loader, { LoaderTypes } from 'components/loader/Loader';

//Styles
import './button.scss';


interface ButtonProps {
    isLoading?: boolean;
    showIcon?: boolean;
    hideText?: boolean;
    disabled?: boolean;
    icon?: IconDefinition;
    tab?: boolean;
    loadingText?: string;
    text?: string;
    type?: string;
    onClick?: () => void;
}


const Button = (props: ButtonProps) => {
    return (
        <button 
            type="button"
            className={clsx(
                "button",
                props.type && props.type, 
                props.tab && "tab", 
                props.hideText && "hide-text", 
                props.isLoading && "loading",
                props.disabled && "disabled"
            )}
            onClick={props.onClick} 
        >
            {props.isLoading ?
                <div className="button_loader">
                    <Loader 
                        type={LoaderTypes.Small} 
                        isLoading
                        loadingText={props.loadingText}
                    />
                </div> :
                <Fragment>
                    {props.showIcon ? <FontAwesomeIcon icon={props.icon} className="button-icon" /> : null} {props.hideText ? null : <span>{props.text}</span>}
                </Fragment>
            }
        </button>
    )
}


export default Button;